'use strict';

import Vue from 'vue';
import VueMask from 'v-mask';
import Event from './event';
import Config from '../config';
import Module from '../modules/';
import components from '../modules/components';

export default class {

    constructor() {
        this.token = document.head.querySelector('meta[name="csrf-token"]').content;
        this.event = new Event();
        this.config = Config;
        this.countries = [];
        this.user = [];

        Vue.use(VueMask);
        
        this.header = new Module.Header();
        this.footer = new Module.Footer();
        this.magnificPopup = new Module.MagnificPopup();

        new Module.AddToCart();
        new Module.CartNumItems();
        new Module.Checkout();
        new Module.PasswordChange();
        new Module.EditOrder();
        new Module.EventOver();
    }

    init(url) {
        this.url = url.replace(/\/+$/, "");

        // - Trigger cookie consent banner.
        cookieconsent.initialise(Config.cookieconsent);

        this.header.init();
        this.magnificPopup.init();

        this.fetchUser().then(() =>{
            this.vue = new Vue({
                el: '#app',
                components
            });
            this.cartData();

            $('.showLoading').click(function() {
                swal({
                    title: '',
                    text: 'Laden bitte warten...',
                    showConfirmButton: false,
                    type: ''
                });
            });

            $.datepicker.setDefaults( $.datepicker.regional[ "de" ] );
            $('#datepickerstart').datepicker({
                changeMonth: true,
                changeYear: true
            });
            $('#datepickerend').datepicker({
                changeMonth: true,
                changeYear: true
            });

            $('.select2Categories').select2();

            $('.popup-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: false,
                    navigateByImgClick: false,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                }
            });
            $('.popup-modal').magnificPopup({
                type: 'inline',
                preloader: false,
                focus: '#username',
                modal: true
            });
            $(document).on('click', '.popup-modal-dismiss', function (e) {
                e.preventDefault();
                $.magnificPopup.close();
            });
        })

        this.fetchCountries();        
    }

    cartData() {
        new Form().get('/api/cart/content')
            .then((response) => {
                this.event.fire('cart.data.loaded', response);
            });
    }

    fetchCountries() {
        new Form().get('/register/countries')
            .then(countries => {
                this.countries = countries;
                this.event.fire('countries.loaded', countries);
            });
    }

    fetchUser() {
        return new Form().get('/api/me')
                .then(user => this.user = user );
    }

}